import useApi from "hooks/useApi";
import { useMutation } from "react-query";
import { handleAxiosError } from "./utils";
import { CreateOrderRequest, CreateOrderResponse, CreateOrderResponseSchema } from "../Types/CreateOrder";
import { z } from "zod";

const CREATE_ORDER_ENDPOINT = "/create-order";

/**
 * React Query hook for creating orders with manual execution control
 * @returns Mutation object to trigger the API call with request payload
 */
export default function useQueryCreateOrder() {
  const api = useApi();

  const createOrder = async (createOrderRequest: CreateOrderRequest): Promise<CreateOrderResponse> => {
    try {
      const { data } = await api.post(CREATE_ORDER_ENDPOINT, createOrderRequest);
      return CreateOrderResponseSchema.parse(data);
    } catch (e) {
      if (e instanceof z.ZodError) {
        return Promise.reject(e.message);
      }
      return handleAxiosError(e);
    }
  };

  return useMutation<CreateOrderResponse, string, CreateOrderRequest>(createOrder);
}
